import RowCell from 'components/Grids/DataGrid/Cells/RowCell';
import { appReactMemo } from 'hocs';
import { formatByteToKB } from 'utils/common';

import { TReportRowCellProps } from './types';

const SizeCell = ({ item, ...rest }: TReportRowCellProps) => {
  const { size } = item;
  const fileSize = size ? formatByteToKB(size) : '-';

  return (
    <RowCell {...rest} item={item}>
      {fileSize}
    </RowCell>
  );
};

export default appReactMemo(SizeCell);
